<script setup lang="ts">
useHead({
  titleTemplate: (title) => (title ? `${title} - Wijsneus` : "Wijsneus"),
  link: [
    {
      rel: "icon",
      type: "image/png",
      sizes: "96x96",
      href: "/attributes/favicon-96x96.png",
    },
    { rel: "icon", type: "image/svg+xml", href: "/attributes/favicon.svg" },
    { rel: "shortcut icon", href: "/attributes/favicon.ico" },
    {
      rel: "apple-touch-icon",
      sizes: "180x180",
      href: "/attributes/apple-touch-icon.png",
    },
    { rel: "manifest", href: "/attributes/site.webmanifest" },
  ],
  meta: [
    { name: "description", content: "Your personal AI Sidekick" },
    { name: "apple-mobile-web-app-title", content: "Wijsneus" },
  ],
});
</script>

<template>
  <NuxtLayout class="layout">
    <NuxtPage />
  </NuxtLayout>
</template>

<style lang="scss">
:root {
  --page-transition-duration: 200ms;
}

html {
  font-family: "Manrope", sans-serif;
  // background-image: url("../images/cursor.svg");
  // cursor: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 31"><path style="stroke:none;fill-rule:nonzero;fill:%23fff;fill-opacity:1" d="M18.188 4.094a2.003 2.003 0 0 0 0 2.894l-.997-.965c-.828-.8-2.168-.8-2.996 0a1.997 1.997 0 0 0 0 2.895l-1-.965c-.824-.8-2.168-.8-2.992 0a1.992 1.992 0 0 0 0 2.89L4.27 5.114l-.012-.015a2.173 2.173 0 0 0-3.02-.02 2 2 0 0 0 .012 2.914c.008.004.012.012.02.02l7.988 7.718a3.326 3.326 0 0 1 .004 4.82 4.417 4.417 0 0 1-.5.485c-1.348 1.11-2.649.82-3.992 1.93-.196.16-.36.324-.5.48a1.997 1.997 0 0 0 0 2.895.069.069 0 0 1 .015.02c1.89 2 8.969-2 13.703.206.59.274 2.106 1.09 3.711.641a3.851 3.851 0 0 0 1.54-.867l6.491-6.27a5.333 5.333 0 0 0 0-7.718L21.184 4.09a2.176 2.176 0 0 0-2.997 0Zm0 0"/><path style="stroke:none;fill-rule:nonzero;fill:%23000;fill-opacity:1" d="M20.719 27.934c-1.258 0-2.34-.516-2.867-.77-.047-.02-.09-.043-.13-.059-2.347-1.093-5.378-.53-8.058-.039-2.523.47-4.707.872-5.82-.296a2.56 2.56 0 0 1-.809-1.875c0-.707.278-1.356.781-1.852.172-.191.356-.371.555-.531.766-.633 1.531-.871 2.207-1.078.645-.204 1.207-.375 1.785-.852a3.979 3.979 0 0 0 .465-.453 2.735 2.735 0 0 0-.004-3.973L.836 8.434l-.02-.02-.011-.012A2.587 2.587 0 0 1 .8 4.656a2.809 2.809 0 0 1 3.87 0c.005.008.013.012.016.02a.03.03 0 0 1 .016.015l4.32 4.172c.106-.504.36-.965.743-1.332.87-.843 2.191-.996 3.226-.46a2.58 2.58 0 0 1 .77-1.47c.87-.843 2.187-.996 3.222-.46a2.58 2.58 0 0 1 .77-1.47 2.804 2.804 0 0 1 3.867 0l8.543 8.259A5.91 5.91 0 0 1 32 16.21c0 1.618-.652 3.138-1.836 4.282l-6.488 6.27-.016.015a4.5 4.5 0 0 1-1.789 1.004c-.394.11-.781.153-1.152.153Zm-6.278-2.645c1.325 0 2.633.191 3.813.742.043.02.09.04.14.067.606.289 1.868.89 3.137.535.457-.125.89-.371 1.282-.723l6.484-6.262a4.747 4.747 0 0 0 0-6.875L20.75 4.516a1.541 1.541 0 0 0-2.125 0 1.408 1.408 0 0 0-.004 2.046l.004.004c.238.23.238.61 0 .844a.635.635 0 0 1-.871 0l-.996-.965a1.546 1.546 0 0 0-2.13 0 1.419 1.419 0 0 0 0 2.051c.243.23.243.61 0 .84a.626.626 0 0 1-.866.004l-1-.965a1.541 1.541 0 0 0-2.125 0 1.408 1.408 0 0 0 0 2.047.58.58 0 0 1 0 .844.623.623 0 0 1-.867 0c-.243-.23-.004 0-.004 0L3.844 5.539l-.008-.004-.02-.02-.02-.019a1.545 1.545 0 0 0-2.124.004 1.412 1.412 0 0 0-.004 2.05c.004.005.008.013.016.016l.004.008.019.016 7.988 7.719a3.914 3.914 0 0 1 .02 5.648 4.748 4.748 0 0 1-.555.531c-.765.633-1.531.871-2.207 1.078-.648.204-1.207.375-1.785.852a3.92 3.92 0 0 0-.43.414l-.035.035c-.281.274-.437.64-.437 1.028 0 .37.144.722.41.992.027.023.05.047.074.074.656.68 2.613.316 4.684-.066 1.539-.286 3.289-.606 5.011-.606ZM3.848 5.543v.004Zm0 0"/></svg>');
  overflow: hidden;
  transition: background-color calc(var(--page-transition-duration) * 2) ease;
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  margin: 0;
  padding: 0;

  // &.has-overlay {
  //   background-color: #000 !important;
  // }
}

body {
  margin: 0;
  // The Capacitor Keyboard plugin's autoBackdropColor="dom" setting reads
  // this element's own background to color the area behind the keyboard,
  // but the theme background is only ever set on <html> (see layouts/*.vue).
  background-color: inherit;
  overflow: hidden;
}

p {
  margin: 0;
  padding: 0;
}

a {
  text-decoration: underline;
}

input,
textarea,
[contenteditable="true"] {
  -webkit-user-select: text;
  user-select: text;
  -webkit-touch-callout: default;
}

// a,
// button {
//   cursor:
//     url("~assets/images/cursor.png") 4 5,
//     pointer;
// &:active {
//   cursor: pointer;
// }
// }

#__nuxt {
  display: flex;
  flex-direction: column;
  // --keyboard-height is only ever set on native (see
  // plugins/keyboardInset.client.ts); on web this is plain 100dvh, unchanged
  // from browser default.
  height: calc(100dvh - var(--keyboard-height, 0px));
  scale: 1;
  transition:
    scale 300ms ease,
    border-radius 300ms ease,
    height 400ms ease-in-out;

  &.has-overlay {
    scale: 0.8;
    // border-radius: 20px;
  }
}

.page-enter-active,
.page-leave-active {
  transition: all var(--page-transition-duration) ease;
}
.page-enter-from,
.page-leave-to {
  filter: blur(2px);
  opacity: 0;
}
</style>
